export default "__VITE_ASSET__68d7b485__"